import React from 'react';
import * as Styles from './HowItWorks.styles';
import { IconExternal } from '@/icons';

const HowItWorks = ({
  title,
  linkLabel,
  linkUrl,
  steps,
  testId = 'how-it-works',
}) => (
  <Styles.Wrapper data-testid={testId}>
    <Styles.Header>
      <Styles.Title>{title}</Styles.Title>
      <Styles.Link href={linkUrl} target="_blank" rel="noopener noreferrer">
        {linkLabel}
        <IconExternal size={16} color="currentColor" />
      </Styles.Link>
    </Styles.Header>

    <Styles.StepsContainer>
      {steps.map((step) => {
        const IconComponent = step.icon;
        return (
          <Styles.StepCard key={step.id}>
            <Styles.IconWrapper>
              <IconComponent color="#1F2044" size={24} />
            </Styles.IconWrapper>
            <Styles.StepContent>
              <Styles.StepLabel>{step.step}</Styles.StepLabel>
              <Styles.StepTitle>{step.title}</Styles.StepTitle>
              <Styles.StepDescription>{step.description}</Styles.StepDescription>
            </Styles.StepContent>
          </Styles.StepCard>
        );
      })}
    </Styles.StepsContainer>
  </Styles.Wrapper>
);

export default HowItWorks;
